export const statusTypes = [
  {
    text: 'Not participant',
    value: 'unregistered',
  },
  {
    text: 'Participant',
    value: 'active',
  },
  {
    text: 'Ban',
    value: 'banned',
  },
]
